import React from 'react';
import Hero from '../components/Hero';
import CategoryGrid from '../components/CategoryGrid';
import { ListingGrid } from '../components/ListingGrid';
import { SectionHeading } from '../components/SectionHeading';
import { DiasporaBanner } from '../components/landing/DiasporaBanner';
import { HowItWorks } from '../components/landing/HowItWorks';
import { Monetization } from '../components/landing/Monetization';
import { Testimonials, CtaBanner } from '../components/landing/Testimonials';
import { useApp } from '../context/AppContext';
import { useApi } from '../hooks/useApi';

const ListingsSection = ({ title, subtitle, params, testId }) => {
  const { t } = useApp();
  const { data, loading, error, reload } = useApi('/listings', params);
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-testid={testId}>
      <SectionHeading title={title} subtitle={subtitle} linkTo="/marketplace" linkLabel={t('cat.viewAll')} />
      <ListingGrid listings={data} loading={loading} error={error} onRetry={reload} testId={`${testId}-grid`} />
    </section>
  );
};

const Landing = () => {
  const { t } = useApp();
  return (
    <div data-testid="landing-page">
      <Hero />
      <CategoryGrid />
      <ListingsSection title={t('feat.title')} subtitle={t('feat.subtitle')} params={{ boosted: true, limit: 4 }} testId="landing-featured-section" />
      <DiasporaBanner />
      <HowItWorks />
      <ListingsSection title={t('land.recent')} params={{ sort: 'recent', limit: 8 }} testId="landing-recent-section" />
      <Monetization />
      <Testimonials />
      <CtaBanner />
    </div>
  );
};

export default Landing;
